import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, PublicPolicy } from './App.tsx';
import { DemoBackend } from './backend/demo.ts';
import { SupabaseBackend } from './backend/supabase.ts';
import type { Backend } from './backend/types.ts';
import { SUPABASE_ANON_KEY, SUPABASE_URL } from './config.ts';
import { ModelProvider } from './state.tsx';
import './styles.css';

// ?demo runs on seeded data kept in this browser (previews and the end-to-end tests); ?demo=reset starts over.
const params = new URLSearchParams(location.search);
if (params.has('demo')) {
  sessionStorage.setItem('recover.demo', params.get('demo') ?? '');
  history.replaceState(null, '', location.pathname + location.hash); // a reload must not reset the demo again
}
const demo = sessionStorage.getItem('recover.demo');
const backend: Backend = demo !== null ? new DemoBackend(demo === 'reset') : new SupabaseBackend(SUPABASE_URL, SUPABASE_ANON_KEY);
if (demo === 'reset') sessionStorage.setItem('recover.demo', '');

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    {location.pathname.replace(/\/$/, '') === '/privacy'
      ? <PublicPolicy />
      : <ModelProvider backend={backend}><App /></ModelProvider>}
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js'); });
}
